// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Uo-z","breadcrumbForward":"Vo-z","breadcrumbBack":"Wo-z","selected":"Xo-z"};